export enum VestaCommandType {
  VirginStructure = 'virgin-structure',
  ViewUpdate = 'view-update',
  AnnotationUpdate = 'annotation-update',
}
